/**
 * Audio Integration
 */

import Plyr from 'plyr';
import $ from 'jquery';

export default function pandaAudio () {

  const selectorAudio = $('.pandaAudio__container');

  const plyrInstances = [];
  selectorAudio.each(function () {
    const $this = $(this);
    const playerId = '#' + $this.attr('id');
    const playerConst = ['play', 'progress', 'duration', 'current-time'];

    const plyrInstance = new Plyr(playerId, {
      controls: playerConst,
      disableContextMenu: true,
      tooltips: {controls: false, seek: false}
    });
    plyrInstances.push(plyrInstance);
  });

  return Promise.resolve({
    destroy: () => {
      plyrInstances.forEach(plyrInstance => plyrInstance.destroy());
    }
  });

}
